import { render, staticRenderFns } from "./factsDialog.vue?vue&type=template&id=b510f12c&scoped=true"
import script from "./factsDialog.vue?vue&type=script&lang=js"
export * from "./factsDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b510f12c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/devjobs/builds/JYRJr4p_y/0/supplyonline/covisint-cn-mcd/srm/mcd-srm-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b510f12c')) {
      api.createRecord('b510f12c', component.options)
    } else {
      api.reload('b510f12c', component.options)
    }
    module.hot.accept("./factsDialog.vue?vue&type=template&id=b510f12c&scoped=true", function () {
      api.rerender('b510f12c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/page/RMC/Protein/rmcScore/dialog/factsDialog.vue"
export default component.exports